import { FormInputComponents } from '../support.type';
import { FormField } from './FormField';
import { type UploadFile } from '@components/util/FileUploader.vue';
import { UploadPhotoApiApiUploadPhotoUploadPost } from '@clients/SupportApi';

export class FormFieldImageUploader extends FormField<UploadFile[]> {
    private _imagePath = '';
    override component = FormInputComponents.FileUploader;
    private isUploading = false;
    private async uploadPhoto(file: File) {
        const { data } = await UploadPhotoApiApiUploadPhotoUploadPost({ file });
        return data.fileUrl;
    }

    private async uploader(val: File) {
        this.isUploading = true;
        const imgPath = await this.uploadPhoto(val);
        this._imagePath = imgPath || '';
        this.isUploading = false;
    }

    override get data() {
        return this._imagePath;
    }

    override validator() {
        if (this.isUploading) {
            return 'در حال بارگذاری فایل‌ها...';
        }
        if (!this._imagePath && this.isRequired) {
            this._isValid = false;
            return this.requiredError;
        }
        return true;
    }

    override updateValue(val: UploadFile[] | null) {
        super.updateValue(val);
        if (!val) {
            return;
        }
        this.uploader(val[0].file);
    }
}
